import React, { useEffect, useState } from "react";
import {
  BsCheck2Circle,
  BsFillTelephoneOutboundFill,
  BsPersonCheckFill,
} from "react-icons/bs";
import { FaAddressCard } from "react-icons/fa";
import styled from "styled-components";
import { useStateContext } from "../contexts/ContextProvider";
import Confetti from "react-confetti";
import { RiUserLocationLine } from "react-icons/ri";
import { MdOutlineShoppingCart, MdLocationOn } from "react-icons/md";
import { useNavigate } from "react-router-dom";
const CheckoutSuccess = () => {
  const { address, getOrderAddress, user, setCartItem } = useStateContext();
  const navigate = useNavigate();
  const [hurray, setHurray] = useState(true);
  useEffect(() => {
    if (user) {
      getOrderAddress(user.email);
    }
    let del = [];
    localStorage.setItem("cartitems", JSON.stringify(del));
    setCartItem(del);
    setTimeout(() => {
      setHurray(false);
    }, 7000);
  }, [user]);
  const width = window.innerWidth;
  const height = window.innerHeight;
  return (
    <Component>
      {<Confetti width={width} height={height} tweenDuration={4000} />}

      <OrderedContainer>
        {/* Header */}
        <Header>
          <div className="successCircle">
            <BsCheck2Circle className="emoji" />
          </div>
          <p>Order Successfully Placed</p>
        </Header>

        {/* Shipping Address */}
        <p>to:</p>
        <Body>
          {address && (
            <div>
              <p>
                <FaAddressCard /> {address[0]?.addressLine1}
              </p>
              <p>
                <MdLocationOn /> {address[0]?.addressLine2}
              </p>
              <p>
                <RiUserLocationLine /> {address[0]?.city}
              </p>
              <p>
                <BsFillTelephoneOutboundFill /> {address[0]?.phone_no}
              </p>
              <p>
                <BsPersonCheckFill /> {address[0]?.recievers_name}
              </p>
            </div>
          )}
        </Body>

        {/* Buttons */}
        <Botton>
          <button
            onClick={() => {
              navigate(`/`);
            }}
          >
            Contine Shopping{" "}
            <MdOutlineShoppingCart style={{ marginLeft: 10 }} />{" "}
          </button>
        </Botton>
      </OrderedContainer>
    </Component>
  );
};

export default CheckoutSuccess;

const Component = styled.div`
  margin-top: 10vh;
  width: 100vw;
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OrderedContainer = styled.div`
  padding: 10px;
  width: 30vw;
  height: 70vh;
  border: 1px solid pink;
  background-color: #fffbfe;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  box-shadow: 7px 6px 5px 0px rgba(0, 0, 0, 0.19);
  -webkit-box-shadow: 7px 6px 5px 0px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 7px 6px 5px 0px rgba(0, 0, 0, 0.19);


    @media (max-width: 470px) {
    width: 80vw;
  height: 70vh;
  }
`;

const Header = styled.div`
  height: auto;
  display: flex;
  width: 90%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #ebd4e6;
  .successCircle {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: #efc9e0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #074f0d;
  }
  p {
    color: #076e10;
    font-weight: 800;
  }
`;
const Body = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  width: 90%;
  p {
    display: flex;

    align-items: center;
    svg {
      margin-right: 30px;
      font-size: 19px;
      color: #8f8f8f;
    }
  }
`;

const Botton = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  bottom: 0;
  height: 10vh;
  width: 70%;
  border-top: 1px solid #4c3434;

  button {
    width: 100%;
    height: 34px;
    border: 1px solid #f3a5e3;
    border-radius: 7px;

    background: linear-gradient(to bottom, #f4aede, #f46cd4);
    cursor: pointer;
    box-shadow: 0 1px 0 rgb(255 255 255 / 40%) inset;
    box-shadow: 2px 2px 7px 3px rgba(215, 70, 162, 0.4);
    :hover {
      transform: scale(1.02);
    }
    transition: 0.4s ease-in-out;
  }
`;
